export const UPDATE_ALUNOS_FREQUENCIA = 'UPDATE_ALUNOS_FREQUENCIA'
export const ADD_ALUNOS_FREQUENCIA = 'ADD_ALUNOS_FREQUENCIA'
export const SET_ALUNOS_FREQUENCIA = 'SET_ALUNOS_FREQUENCIA'
export const REMOVE_ALUNOS_FREQUENCIA = 'REMOVE_ALUNOS_FREQUENCIA'
export const SET_ALUNO_FREQUENCIA = 'SET_ALUNO_FREQUENCIA'